import { apiFetch } from "./client";
import type { Me, PublicConfig, TokenExchangeResponse } from "./types";

/** Public runtime config — fetched once at startup, before auth. */
export function getPublicConfig() {
  return apiFetch<PublicConfig>("/api/v1/config");
}

/** Exchange a verified Entra ID token for an OpenWatch session JWT. */
export function exchangeTeamsSso(entraToken: string) {
  return apiFetch<TokenExchangeResponse>("/api/v1/auth/teams-sso", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: entraToken }),
  });
}

/** Current user profile — drives the sidebar footer + access checks. */
export function getMe() {
  return apiFetch<Me>("/api/v1/auth/me");
}